import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';

/**
 * Generates a `send` method for submitting CET data if there is data available.
 * @param  {Boolean} options.debug - If true, will assume testing on non-prod environments. For
 * example,the stage endpoint will be used.
 * @return {Function} obj.send
 */
var createDispatcher = function createDispatcher() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      debug = _ref.debug;

  var endpoint = debug ? 'https://pixiedust-stage.buzzfeed.com/events' : 'https://pixiedust.buzzfeed.com/events';

  var send = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var data,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];

              if (data && data.length) {
                navigator.sendBeacon(endpoint, JSON.stringify(data));
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function send() {
      return _ref2.apply(this, arguments);
    };
  }();

  return {
    send: send
  };
};

export { createDispatcher };
